/* eslint-disable operator-assignment */
import type { DSHookFloatingContextT } from '../react-desc-prop-types.js';

function getMainAxisFromPlacement(placement: DSHookFloatingContextT.PopperPlacementsT) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

export default function computeOffsets(
  placement: DSHookFloatingContextT.PopperPlacementsT,
  referenceRect: DOMRect,
  floatingRect: DOMRect,
) {
  const basePlacement = placement.split('-')[0];
  const constiation = placement.split('-')[1];
  const commonX = referenceRect.x + referenceRect.width / 2 - floatingRect.width / 2;
  const commonY = referenceRect.y + referenceRect.height / 2 - floatingRect.height / 2;
  let offsets: { x: number; y: number } = { x: 0, y: 0 };

  switch (basePlacement) {
    case 'top':
      offsets = {
        x: commonX,
        y: referenceRect.y - floatingRect.height,
      };
      break;

    case 'bottom':
      offsets = {
        x: commonX,
        y: referenceRect.y + referenceRect.height,
      };
      break;

    case 'right':
      offsets = {
        x: referenceRect.x + referenceRect.width,
        y: commonY,
      };
      break;

    case 'left':
      offsets = {
        x: referenceRect.x - floatingRect.width,
        y: commonY,
      };
      break;

    default:
      offsets = {
        x: referenceRect.x,
        y: referenceRect.y,
      };
  }

  const mainAxis = basePlacement
    ? getMainAxisFromPlacement(basePlacement as DSHookFloatingContextT.PopperPlacementsT)
    : null;

  if (mainAxis != null) {
    const len = mainAxis === 'y' ? 'height' : 'width';

    switch (constiation) {
      case 'start':
        offsets[mainAxis] = offsets[mainAxis] - (referenceRect[len] / 2 - floatingRect[len] / 2);

        break;

      case 'end':
        offsets[mainAxis] = offsets[mainAxis] + (referenceRect[len] / 2 - floatingRect[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
